import { WriteableNote } from "src/app/interfaces/writeable-note.interface";

export class CreateNoteRequest {
	constructor() {
		this.notes = [];
	}

	diaryId: string;
	notes: WriteableNote[];
}
